var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calculator--check_svg__clip0_61530_7361)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 19.942L16.058 18 15 19.058l3 3 5.25-5.25-1.058-1.058L18 19.942zM12.75 17.25h-1.5v1.5h1.5v-1.5zM8.25 17.25h-1.5v1.5h1.5v-1.5zM17.25 13.5h-1.5V15h1.5v-1.5zM12.75 13.5h-1.5V15h1.5v-1.5zM8.25 13.5h-1.5V15h1.5v-1.5zM17.25 9.75h-1.5v1.5h1.5v-1.5zM12.75 9.75h-1.5v1.5h1.5v-1.5zM8.25 9.75h-1.5v1.5h1.5v-1.5zM17.25 5.25H6.75V7.5h10.5V5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.5H4.503A1.505 1.505 0 013 20.996V2.997A1.499 1.499 0 014.497 1.5h15.006A1.499 1.499 0 0121 2.997V13.5h-1.5V3h-15v18h8.25v1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calculator--check_svg__clip0_61530_7361"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCalculatorCheck;